import Vue from 'vue';
import Chartist from 'vue-chartist';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'chartist/dist/chartist.min.css';

Vue.use(Chartist);
